import type {} from "@next/third-parties/google";
import { getTracking } from "@website/store/tracking";
import { AddEventToDataLayerType } from "@website/tracking/tracking.types";
import { getChannel } from "@website/utils/channel/get-channel";
import { isSSR } from "@website/utils/is-ssr";
import isArray from "lodash-es/isArray";
import toString from "lodash-es/toString";

const getActiveGrowthbookExperiments = () =>
  Object.entries(getTracking().experiment ?? {})
    .filter(([, variationName]) => variationName !== undefined)
    .map(([experimentName, variationName]) => ({
      experiment_name: toString(experimentName),
      variation_name: toString(variationName)
    }));

export const addEventToDataLayer: AddEventToDataLayerType = (
  event,
  dataLayerData
) => {
  if (isSSR()) return;
  window.dataLayer ||= [];
  const passedData =
    getChannel() === "b2b" && isArray(dataLayerData?.items)
      ? dataLayerData?.items.map((item) => ({
          ...item,
          ...(item.item_brand && { item_brand: "b2b" })
        }))
      : dataLayerData;

  const experiments = getActiveGrowthbookExperiments();

  window.dataLayer.push({
    event,
    ecommerce: passedData,
    ...(experiments.length > 0 ? { experiments } : {})
  });
};
